import { render } from "./UpdateCustomAction.vue?vue&type=template&id=5d60211f&scoped=true"
import script from "./UpdateCustomAction.vue?vue&type=script&lang=js"
export * from "./UpdateCustomAction.vue?vue&type=script&lang=js"

import "./UpdateCustomAction.vue?vue&type=style&index=0&id=5d60211f&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d60211f"]])

export default __exports__